module.exports = __webpack_public_path__ + "img/phone-bg.bc0b0462.jpg";